<template>	
		<div class="survey-post">
				
				<div class="survey-post-top">
                    <div class="deleteSurvey">
						<button class="del-btn" v-if="isAdmin"  @click="openDeleteModal(surveyData.survey.quoteReference)"></button>
					</div>
					<deleteSurveyConfirmModal :quoteReference="surveyData.survey.quoteReference" quoteStatus="Open Quotations"/>
					
                    <div class="survey-post-top-attributes col md-7">	
						<div class="quoteNumber">
							<span class="survey-post-title">Quote Number</span>
							<span class="survey-post-entry">{{surveyData.survey.quoteReference}}</span>
						</div>
                        <div class="client" v-if="isAdmin">
                            <span class="survey-post-title">Client</span>
							<span class="survey-post-entry">{{surveyData.user.alias}}</span>
                        </div>
                        <div class="companyName" v-if="isAdmin">
                            <span class="survey-post-title">Company Name</span>
							<span class="survey-post-entry">{{surveyData.user.companyName}}</span>
                        </div>
						<div class="areas">
							<span class="survey-post-title">Areas</span>
							<span class="survey-post-entry">{{surveyData.areas.length}}</span>
						</div>
						<div class="totalarea">
							<span class="survey-post-title">Total Area</span>
							<span class="survey-post-entry">{{surveyData.survey.totalArea | currency('', 0)}}sqm</span>
						</div>
						<div class="totalarea">
							<span class="survey-post-title">Total Cost</span>
							<span class="survey-post-entry">{{surveyData.survey.quotePrice | currency('£')}}</span>
						</div>
                        <div class="paymentType">
							<span class="survey-post-title">Payment Method</span>
							<span class="survey-post-entry">{{surveyData.survey.paymentType}}</span>
						</div>
                        <div class="startDate">
							<span class="survey-post-title">Date Started</span>
							<span class="survey-post-entry">{{surveyData.survey.surveyStartDate | niceDate}}</span>
						</div>
                        <div class="status" v-if="!isAdmin">
							<span class="survey-post-title">Status</span>
							<span class="survey-post-entry">Ongoing</span>
						</div>
					</div>

					<div class="survey-post-top-controls col md-5">	
						<div class="admin__download" v-if="isAdmin">
							<a download :href="surveyData.survey.quoteFilesUrl" class="btn btn-small">&nbsp;</a>
						</div>
                        <div class="open-toggle">
                            <button class="btn btn-small view__toggle" @click="openClose">
                                {{toggled === surveyData.survey.quoteReference ? 'Close' : 'View'}}
                            </button>
                        </div>
					</div>
                    <div class="clearfix"></div>
				</div>

				<div class="survey-post-body">

                    <div class="progress">
                        <p class="progress__subhead">Progress</p>
                        <div class="progress__title">{{this.surveyProgressDef[surveyData.survey.surveyProgress]}}</div>
                        <div class="progress-bar">
                            <div class="progress-bar-inner" :style="{width: surveyData.survey.surveyProgress.toString() + '%'}">
                                <span :class="{ altStyle : surveyData.survey.surveyProgress < 10}">{{surveyData.survey.surveyProgress}}%</span>
                            </div>
                        </div>
                        <div class="update-progress" v-if="isAdmin" v-show="toggled == surveyData.survey.quoteReference">
                            <div class="col md-9 progress-stages">
                                <select name="surveyProgress" id="" 
                                    @change="changeSelectedSurveyProgress"  
                                    :selected="selectedSurveyProgress">
                                    <option 
                                        v-for="(val, i) in surveyProgressDef" 
                                        :key="i"
                                        :value="i"
                                        :default="surveyData.survey.surveyProgress == i"
                                        :disabled="i == 100"
                                    >
                                        {{val}}
                                    </option>
                                </select>
                            </div>

                            <div class="col md-3 progress-confirm">
                                <button class="btn btn-small" 
                                    :disabled="selectedSurveyProgress === surveyData.survey.surveyProgress"
                                    @click="updateSurveyProgress"
                                >Update Status</button>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    
					<div class="complete-and-survey" v-if="isAdmin" v-show="toggled == surveyData.survey.quoteReference">
                        <div class="client-details__title">Complete Survey</div>
                        <div class="complete__upload col md-3">
                            <input type="file" name="surveyPdf" :disabled="cantCompleteSurvey" @change="handleFileChange">
                        </div>
                        <div class="complete__send col md-3">
                            <button 
                                class="btn primary" 
                                :disabled="cantCompleteSurvey || uploadData.surveyPdf == false || forceDisableSendFinalSurvey == true"
                                @click="completeSurvey"
                            >
                                Send package
                            </button>
                        </div>
                        <div class="clearfix"></div>
                    </div>

                    <div class="dropdown" v-show="toggled == surveyData.survey.quoteReference">

                        <div class="client-details" v-if="isAdmin">	
                            <div class="client-details__title">Client Contact Info</div>
                                <div class="client-details__email">	
                                    <span class="client-details__desc">Email Address:</span>
                                    <span>{{surveyData.user.email}}</span>
                                </div>
                                <div class="client-details__phone" v-if="surveyData.user.phoneNumber">	
                                    <span class="client-details__desc">Primary Phone number :</span>
                                    <span>{{surveyData.user.phoneNumber}}</span>
                                </div>
                                <div class="client-details__phone" v-if="surveyData.user.phoneNumberTwo">	
                                    <span class="client-details__desc">Secondary Phone number : </span>
                                    <span>{{surveyData.user.phoneNumberTwo}}</span>
                                </div>

                                <div class="client-details__access" v-if="surveyData.survey.accessArrangements">	
                                    <span class="client-details__desc">Access Arrangments: </span>
                                    <span 
                                        v-for="(deet, i) in surveyData.survey.accessArrangements"
                                        :key="'accessArr-' + deet"
                                        v-if="surveyData.survey.accessArrangements[i]"
                                    >
                                    {{i | camelToNormal }} - {{deet}}
                                    </span>
                                </div>

                                <div class="PO" v-if="surveyData.survey.paymentType === 'invoice'">
                                   <span class="client-details__desc">PO Number: </span>{{surveyData.survey.payment.purchaseOrderNumber}}
                                </div>
                        </div>


                    
                        <div class="survey-post-area" v-for="(area, i) in surveyData.areas" :key="i">
                            <div class="indexer">
                                {{ i + 1}} of {{surveyData.areas.length}}
                            </div>
                            <div class="map-viewer"  v-if="isAdmin">
                                <button class="btn btn-small"  @click="openPreviewArea(area.areaId)">
                                    View
                                </button>
                                <previewStaticMapModal :key="''+i" :areaTitle="area.areaTitle" :areaDesc="area.areaDescription" :areaId="area.areaId" :coordinates="area.kmlCoordinates"/>
                            </div>
                            <div class="area-top">	
                                <p class="areaId">Area Id - {{area.areaId}}</p>
							    <div class="survey-post__title">{{area.areaTitle | truncate(70)}}</div>
                            </div>
                            <div class="area-bottom">	
                                <div class="totalArea">	
                                    <span class="area-bot__title">Total Area</span>
                                    <span class="area-bot__val">{{area.areaSquared}}</span>
                                </div>
                                <div class="userUpload">	
                                    <span class="area-bot__title">Grid &amp; Height</span>
                                    <span class="area-bot__val">{{area.userUpload === false ? 'Custom uploaded' : 'Related to OS'}}</span>
                                </div>
                                <div class="additionalDetails">	
                                    <span class="area-bot__title">Additional Details</span>
                                    <span class="area-bot__val" v-if="area.additionalDetails.length === 0">No</span>
                    
                                    <span v-if="area.additionalDetails.length > 0" class="area-bot__val additionals">
                                        Yes - {{area.additionalDetails.join(', ')}}
                                    </span>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
					
				</div>

		</div>
</template>

<script>	
import previewStaticMapModal from '../Modals/previewStaticMapModal';
import deleteSurveyConfirmModal from '../Modals/deleteSurveyConfirmModal';
export default {
	props : ['surveyData', 'toggled', 'isAdmin'],
	components : {
		previewStaticMapModal : previewStaticMapModal,
		deleteSurveyConfirmModal : deleteSurveyConfirmModal
	},
	data(){
		return {
            selectedSurveyProgress : this.surveyData.survey.surveyProgress,
            cantCompleteSurvey : this.surveyData.survey.surveyProgress < 80 ? true : false,
            surveyProgressDef : {
                20 : 'Planning site visits',
                40 : 'Undertaking site work',
                60 : 'Processing site work',
                80: 'Quality Control',
                100 : 'Finished!' 
            },
            uploadData : {
				surveyPdf : ""
            },
            forceDisableSendFinalSurvey : false
		}
	},
	methods : {
        handleFileChange(e){
			var file = e.target.files[0]; 
			this.uploadData.surveyPdf = file;
		},
		openClose(){

			this.$emit('openCloseToggle', this.surveyData.survey.quoteReference);
		},
		openPreviewArea(areaId){
			this.$store.commit('openModal', 'previewStaticMapModal' + areaId)
		},
		openDeleteModal(quoteReference){
			this.$store.commit('openModal', 'deleteSurveyConfirmModal' + quoteReference);
		},
		completeSurvey(){
			this.forceDisableSendFinalSurvey = true;
		
			let data = Object.assign({}, this.uploadData);
			if(data.surveyPdf === undefined){
				delete data.surveyPdf
			}
			this.$store.dispatch('completeSurvey', {quoteReference : this.surveyData.survey.quoteReference, data : data})
			.then((response) => {
				this.$toasted.clear()
				this.forceDisableSendFinalSurvey  = false;
				if(response.confirmation === 'success'){
					this.$toasted.success("Survey updated!", {
			            theme: 'bubble',
			            position: 'bottom-center',
			            duration: 5000
                    })
                    this.uploadData.surveyPdf = null;
				} else {
					this.$toasted.error(response.message, {
			            theme: 'bubble',
			            position: 'bottom-center',
			            duration: 5000
			        })
				}
			})
			.catch((err) => {
				this.$toasted.clear()
				this.forceDisableSendFinalSurvey = false;

				this.$toasted.error(err.message, {
			        theme: 'bubble',
			        position: 'bottom-center',
			        duration: 5000
			    })
			})
        },
        changeSelectedSurveyProgress(e){
            let val = Number(e.target.value);
            this.selectedSurveyProgress = val;
        },
        updateSurveyProgress(){
            let payload = {
                quoteReference : this.surveyData.survey.quoteReference,
                data : {
                    surveyProgress : this.selectedSurveyProgress
                }
            }
            this.$toasted.show("Please wait...", {
	            theme: 'bubble',
	            position: 'bottom-center',
	            duration: null
			})
            this.$store.dispatch('updateSurveyData', payload)
            .then((response) => {
                this.$toasted.clear()
				if(response.confirmation === 'success'){
					this.$toasted.success("Survey updated!", {
			            theme: 'bubble',
			            position: 'bottom-center',
			            duration: 5000
                    })
                    if(this.selectedSurveyProgress >= 80){
                        this.cantCompleteSurvey = false
                    } else {
                         this.cantCompleteSurvey = true
                    }
				} else {
					this.$toasted.error(response.message, {
			            theme: 'bubble',
			            position: 'bottom-center',
			            duration: 5000
			        })
				}
			})
			.catch((err) => {
				this.$toasted.clear()
				this.$toasted.error(err.message, {
			        theme: 'bubble',
			        position: 'bottom-center',
			        duration: 5000
			    })
			})
        },
        mounted(){
            console.log('should update');
        }
	}
}
</script>


// WEBPACK FOOTER //
// src/components/common/Dashboard/SurveyPost.vue